import { render } from "./privacyLao.vue?vue&type=template&id=96c32322&scoped=true"
import script from "./privacyLao.vue?vue&type=script&lang=js"
export * from "./privacyLao.vue?vue&type=script&lang=js"

import "./privacyLao.vue?vue&type=style&index=0&id=96c32322&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c32322"]])

export default __exports__